import React from 'react'
import { Button } from 'antd'
import { FormattedMessage } from 'react-intl'
import { ClockCircleOutlined } from '@ant-design/icons'
import cn from 'classnames'

import styles from './financeOnboarding.module.scss'

// Tombol "Nanti saja". Default: tombol sekunder penuh di kartu melayang.
// inline: tombol pill kecil di footer kartu langkah (spotlight).
const SnoozeButton = ({ onClick, inline = false }) => (
  <Button
    size={inline ? 'small' : 'middle'}
    block={!inline}
    icon={inline ? <ClockCircleOutlined /> : undefined}
    onClick={onClick}
    className={cn(styles.snooze, inline && styles.snoozeInline)}
    id="btn-finance-onboarding-snooze"
  >
    <FormattedMessage id="financeOnboarding.snooze" />
  </Button>
)

export default SnoozeButton
